
      import FullscreenExit from './fullscreen-exit.vue'
      import type { App, Plugin } from 'vue'

      export const FullscreenExitPlugin: Plugin = {
        install(app: App) {
          app.component('FullscreenExit', FullscreenExit)
        },
      }
      export { FullscreenExit }
      